import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ index, eyebrow, title, description }) => (
  <div className="mb-14 lg:mb-20">
    <Reveal>
      <div className="flex items-center gap-4 mb-5">
        <span className="font-accent text-emerald-600 text-sm tracking-widest">{index}</span>
        <span className="h-px w-12 bg-emerald-500/50" />
        <span className="font-accent text-stone-500 text-sm tracking-widest">{eyebrow}</span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl leading-snug text-stone-900">
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-stone-500">{description}</p>
      </Reveal>
    )}
  </div>
);
